module.exports = __webpack_public_path__ + "img/figma.bfc8530d.svg";